<template>
  <div class="appliccationBox">
    <div class="unOpen" v-if="open">
      <p>暂未开放在线入驻申请服务</p>
      <span>如需申请入驻,请联系人工客服,客服联系方式:18167176677(微信同号)</span>
    </div>
    <ul v-else>
      <li v-for="(item, index) in list" :key="index" @click="goto(item.businesstype)">
        <i :class="item.className"></i>
        <div class="content">
          <h5>{{ item.name }}</h5>
          <p>{{ item.title }}</p>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: "申请入驻",
    };
  },
  name: "applicationHome",
  data() {
    return {
      list: [
        {
          className: "publicCulture",
          name: "国家公共文化服务机构",
          title: "国家群众文化服务机构及事业单位",
          businesstype: "1000",
        },
        {
          className: "academy",
          name: "国家文化艺术院团",
          title: "政府批准合法成立的文化艺术团体",
          businesstype: "1001",
        },
        {
          className: "trainingInstitution",
          name: "社会艺术培训机构",
          title: "社会民办艺术培训机构及学校",
          businesstype: "1002",
        },
      ],
      open:true,//暂未开放申请入驻
    };
  },
  methods: {
    goto(businesstype) {
      this.$router.push({
        path: "/app/application/publicCulture",
        query: {
          businesstype: businesstype,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.appliccationBox {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #f4f4f7;
  display: flex;
  flex-direction: column;
  ul {
    flex: 1;
    overflow: auto;
    padding: 32px 32px;
    li {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      background: #ffffff;
      box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.03);
      border-radius: 8px;
      margin-bottom: 16px;
      padding: 22px 22px 16px;
      i {
        width: 32px;
        height: 32px;
      }
      i.publicCulture {
        background: url(../../../assets/img/app/publicCulture.png) no-repeat;
        background-size: 32px 32px;
      }
      i.academy {
        background: url(../../../assets/img/app/academy.png) no-repeat;
        background-size: 32px 32px;
      }
      i.trainingInstitution {
        background: url(../../../assets/img/app/trainingInstitution.png)
          no-repeat;
        background-size: 32px 32px;
      }
      .content {
        flex: 1;
        text-align: left;
        margin-left: 22px;
        padding-right: 20px;
        position: relative;
        h5 {
          font-size: 16px;
          font-weight: bold;
          line-height: 22px;
          color: #35363c;
          margin-bottom: 8px;
        }
        p {
          font-size: 12px;
          font-weight: 400;
          line-height: 17px;
          color: #35363c;
          word-break: keep-all;
        }
      }
      .content::before {
        content: " ";
        display: inline-block;
        width: 16px;
        height: 16px;
        background: url(../../../assets/img/app/arrow.png) no-repeat;
        background-size: 16px 16px;
        position: absolute;
        right: 0;
        top: 50%;
        margin-top: -8px;
      }
    }
    li:not(:last-child) {
      margin-bottom: 16px;
    }
  }
  .unOpen{
    flex: 1;
    padding: 0 32px;
    text-align: center;
    background: #ffffff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    >p{
      color: #35363C;
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 10px;
    }
    >span{
      color: #86878A;
      font-size: 14px;
    }
  }
}
</style>>

